"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.APVirtualList = void 0;
var react_1 = __importDefault(require("react"));
var react_virtualized_1 = require("react-virtualized");
var react_window_1 = require("react-window");
var Common_1 = require("./Common");
function APVirtualList(_a) {
    var itemCount = _a.itemCount, itemHeight = _a.itemHeight, children = _a.children, style = _a.style;
    return (react_1.default.createElement("div", { style: style },
        react_1.default.createElement(react_virtualized_1.AutoSizer, null, function (_a) {
            var width = _a.width, height = _a.height;
            return react_1.default.createElement(react_window_1.FixedSizeList, { itemCount: itemCount, itemSize: itemHeight, height: height, width: width }, function (_a) {
                var index = _a.index, style = _a.style;
                return Common_1.APClone({ style: style, children: children({ index: index }) });
            });
        })));
}
exports.APVirtualList = APVirtualList;
